export class ActionArchives {
  elasticIds: string[];
  messagesIds: string[];
  recipients: any[];
  av?: boolean;
}
